import {
  AccessRestricted,
  ShowPageContainer,
} from 'src/components/PageLayout/ShowPage'
import React from 'react'
import { CAPABILITY } from '@trustero/trustero-api-web/lib/authz/permissions_pb'
import { useReadAccess, useRpcReadAccess } from './useReadAccess'

export const ReadAccess = ({
  capabilities,
  children,
}: {
  capabilities: CAPABILITY[]
  children: React.ReactNode
}): JSX.Element | null =>
  useReadAccess(...capabilities) ? <>{children}</> : null

export const ReadAccessDenied = (): JSX.Element => (
  <ShowPageContainer data-testid="show-page-access-restricted">
    <AccessRestricted />
  </ShowPageContainer>
)

// Shared selectors should never mount their querying body when its data source
// is unavailable, including in a modal hosted by another readable feature.
export function withRpcReadAccess<Props>(
  Component: React.ComponentType<Props>,
  method: string,
): (props: Props & React.Attributes) => JSX.Element | null {
  return (props) => (useRpcReadAccess(method) ? <Component {...props} /> : null)
}
